import {request} from "@/backend/backend_util.ts";
import {Holiday} from "@/types/DataTypes.ts";

export const adminBackend = {
    appConfig: request('GET', '/admin/config'),
    saveAppConfig: request('POST', '/admin/config'),
    addHolidays: (payload: Holiday[]) => request<Holiday[]>('POST', '/admin/holidays')(payload),
    copyHolidaysFromPreviousYear: (year: number) => request<Holiday[]>('POST', '/admin/holidays/copy-from-previous-year')({ year }),
    updateHoliday: (id: number, updates: { date?: string }) => request<Holiday[]>('PATCH', `/admin/holidays/${id}`)(updates),
    timeAllocationCategories: request('GET', '/admin/time-allocation-categories'),
    saveTimeAllocationCategory: request('POST', '/admin/time-allocation-categories'),
    deleteTimeAllocationCategory: (key: string) => request('DELETE', `/admin/time-allocation-categories/${key}`)(),
}
